import { LoaderFunctionArgs, redirect } from 'react-router-dom'
import { toast } from 'react-toastify'

import { eventsApi } from '../../../services/events'
import i18n from '../../../i18n'
import type { AppStore } from '../../../store'
import { SessionSchema, SubEventSchema } from '../Events.schema'

export const modifySubEvent =
  (store: AppStore) =>
  async ({ request, params }: LoaderFunctionArgs) => {
    const data = (await request.json()) as SubEventSchema
    const { eventId, subEventId } = params
    const { t } = i18n

    // @ts-expect-error _new is only internal
    delete data._new

    const res = await store.dispatch(
      eventsApi.endpoints.modifySubEvent.initiate({
        eventId: Number(eventId),
        id: Number(subEventId),
        data: data,
      })
    )

    if ('error' in res) {
      toast.error(t("Erreur lors de la mise à jour de l'intervention"))
      return res
    }

    toast.success(t('Intervention modifiée avec succès'))

    return redirect(`/events/${eventId}`)
  }

export const modifySession =
  (store: AppStore) =>
  async ({ request, params }: LoaderFunctionArgs) => {
    const data = (await request.json()) as SessionSchema
    const { eventId, sessionId } = params
    const { t } = i18n

    // @ts-expect-error _new is only internal
    delete data._new

    const res = await store.dispatch(
      eventsApi.endpoints.modifySession.initiate({
        eventId: Number(eventId),
        id: Number(sessionId),
        data: data,
      })
    )

    if ('error' in res) {
      toast.error(t('Erreur lors de la mise à jour de la séance'))
      return res
    }

    toast.success(t('Séance modifiée avec succès'))

    return redirect(`/events/${eventId}`)
  }
